import { defineComponent, toRaw } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import eventBus from '@/services/EventBus';
export default defineComponent({
    name: 'filter-price-range',
    data() {
        return {
            slider: [0, 10000],
        };
    },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        availableFilters: 'availableFilters',
        appliedFilters: 'appliedFilters',
        priceBars: 'priceBars',
    })), { priceBarsView() {
            const bars = structuredClone(toRaw(this.priceBars));
            const counts = bars.map((priceBar) => priceBar.count);
            const maxCount = Math.max(...counts);
            return bars.map((priceBar) => {
                return {
                    height: (priceBar.count / maxCount) * 100,
                    active: priceBar.maxPrice >= this.slider[0] && priceBar.maxPrice <= this.slider[1],
                };
            });
        },
        sliderMinValue() {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.availableFilters) === null || _a === void 0 ? void 0 : _a.priceRange) === null || _b === void 0 ? void 0 : _b.start) !== null && _c !== void 0 ? _c : 0;
        },
        sliderMaxValue() {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.availableFilters) === null || _a === void 0 ? void 0 : _a.priceRange) === null || _b === void 0 ? void 0 : _b.end) !== null && _c !== void 0 ? _c : 0;
        } }),
    methods: Object.assign(Object.assign({}, mapActions('blue', {
        setPriceRange: 'SET_PRICE_RANGE',
    })), { updateMin(minimum) {
            if (typeof minimum !== 'number') {
                minimum = parseInt(minimum);
            }
            this.slider[0] = Math.min(minimum, this.slider[1]);
            console.log({
                input: minimum,
                start: this.slider[0],
                end: this.slider[1],
            });
            this.setPriceRange({
                start: this.slider[0],
                end: this.slider[1],
            });
        },
        updateMax(maximum) {
            if (typeof maximum !== 'number') {
                maximum = parseInt(maximum);
            }
            this.slider[1] = Math.max(maximum, this.slider[0]);
            console.log({
                input: maximum,
                start: this.slider[0],
                end: this.slider[1],
            });
            this.setPriceRange({
                start: this.slider[0],
                end: this.slider[1],
            });
        },
        updateRange() {
            this.setPriceRange({
                start: this.slider[0],
                end: this.slider[1],
            });
        } }),
    mounted() {
        var _a, _b, _c, _d;
        eventBus.on('priceRange:loaded', (payload) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.slider[0] = Math.round(payload.min);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.slider[1] = Math.round(payload.max);
        });
        if (this.appliedFilters.priceRange) {
            this.slider[0] = this.appliedFilters.priceRange.start;
            this.slider[1] = this.appliedFilters.priceRange.end;
            return;
        }
        if (this.priceBars.length) {
            this.slider[0] = (_b = (_a = [...this.priceBars].shift()) === null || _a === void 0 ? void 0 : _a.minPrice) !== null && _b !== void 0 ? _b : 0;
            this.slider[1] = (_d = (_c = [...this.priceBars].pop()) === null || _c === void 0 ? void 0 : _c.maxPrice) !== null && _d !== void 0 ? _d : 0;
        }
    },
});
